import * as consts from '../constants';

class commonApi {
    static loadConfiguration(token) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/configuration/GetConfiguration';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url);

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore nel caricamento della Configurazione!');
                    }
                }
            };
            req.send();
        });
    }
}

export default commonApi;
